// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_MORE_QUESTIONS = "\u010eal\u0161ie ot\u00e1zky";
export const STROLLER_QUESTIONS_AND_ANSWERS = "Ot\u00e1zky a odpovede";
